import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import PayrollInstructionsModal from '@perpay-web/fintech/components/composite/PayrollInstructionsModal/PayrollInstructionsModal';
import {
    STOP_PAYMENT,
    STOP_PAYMENT_CANCELED_WITH_DEDUCTION,
    DELINQUENT,
    LATE,
    GOOD,
} from '@perpay-web/fintech/constants/borrowerStatuses';
import { getUserStatus } from '@perpay-web/fintech/selectors/entities/userStatus';

const userStatusToInstructionsType = (userStatus) => {
    switch (userStatus) {
        case STOP_PAYMENT:
        case STOP_PAYMENT_CANCELED_WITH_DEDUCTION:
            return 'stop';
        case DELINQUENT:
        case LATE:
            return 'late';
        case GOOD:
        default:
            return 'start';
    }
};

const PayrollInstructionsModalContainer = ({
    onClickFinished: ownPropsOnClickFinished,
    skipLanding,
    closeWhenSupportToolLaunched,
    onClose,
    customAmount,
}) => {
    const userStatus = useSelector(getUserStatus);
    const instructionsType = userStatusToInstructionsType(userStatus.status);

    const onClickFinished = useCallback(() => {
        if (ownPropsOnClickFinished) {
            ownPropsOnClickFinished();
        }
    }, [ownPropsOnClickFinished]);

    return (
        <PayrollInstructionsModal
            onClickFinished={onClickFinished}
            skipLanding={skipLanding}
            closeWhenSupportToolLaunched={closeWhenSupportToolLaunched}
            instructionsType={instructionsType}
            onClose={onClose}
            customAmount={customAmount}
        />
    );
};

export default PayrollInstructionsModalContainer;
